import React from 'react';

import { ImagePopupItem as Item } from '../../../typings/images-popup';
import { UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import Image from '../../image/image';
import Text from '../../text/text';

interface Props {
    item: Item;
}

export const ImagePopupItem = (props: Props) => {
    const { url, text } = props.item;
    return (
        <div className={'images-popup__item'}>
            <Image className={'images-popup__item-image'} src={url} />
            <div className={'images-popup__item-text'}>
                <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphSMedium}>{text}</Text>
            </div>
        </div>
    );
};
